// Returns the parsed currentUser by checking pendingLogin's isRememberMe flag
export default function getCurrentUser() {
  try {
    const isRememberMe = localStorage.getItem("isRememberMe") === "true";
    const raw = isRememberMe
      ? localStorage.getItem("currentUser")
      : sessionStorage.getItem("currentUser");

    if (!raw) {
      return null;
    }

    return JSON.parse(raw);
  } catch (e) {
    console.error("getCurrentUser error", e);
    return null;
  }
}
